import qs from 'qs';
import isEmpty from 'lodash/isEmpty';

/**
 * This method parses the router search params which is string and makes it an object
 *
 * @param {String} search      The search string from url
 * @param {Object} params   The key value of query strings which needs to be added
 * @return {Object}
 *
 * Usage:
 * parse('?hello=world') => { hello=world }
 */
export default (search, params = {}) => {
    if (typeof search !== 'string') {
        return {};
    }
    return qs.parse(search, {
        ignoreQueryPrefix: true,
        depth: 0,
        parameterLimit: 100,
        ...params,
    });
};

/**
 * This method stringify the router query params which is object and makes it an string
 *
 * @param {Object} query    The query parameter object format
 * @param {Object} params   The key value of query object which needs to be added
 * @return {String}
 *
 * Usage:
 * parse({ hello: world }) => '?hello=world'
 */
export const stringifyQuery = (query, params = {}) => {
    if (isEmpty(query)) {
        return '';
    }
    return qs.stringify(query, {
        addQueryPrefix: true,
        ...params,
    });
};
